import { CenteredScreen } from '@/shell/CenteredScreen'
import { logout } from '@/auth/logout'
import { Avatar, Button, Card, EmptyRow, Row, Spinner } from '@/ui'
import type { Membership } from '@/api/pending'
import { roleLabel } from './sections'
import styles from './screens.module.css'

export function LoadingScreen() {
  return (
    <div className={styles.loading}>
      <Spinner size={28} />
    </div>
  )
}

export function ErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <CenteredScreen>
      <EmptyRow
        icon="error"
        title="Não foi possível carregar seu acesso"
        description="Verifique sua conexão e tente de novo."
      />
      <div className={styles.actions}>
        <Button onClick={onRetry}>Tentar de novo</Button>
      </div>
    </CenteredScreen>
  )
}

/** Resident-only users: signed in, but nothing to manage. */
export function NoAccessScreen() {
  return (
    <CenteredScreen>
      <EmptyRow
        icon="lock"
        title="Sem acesso de gestão"
        description="Sua conta não tem permissão de gestão em nenhum condomínio. Se isso estiver errado, peça ao síndico para conceder o acesso."
      />
      <div className={styles.actions}>
        <Button variant="secondary" icon="logout" onClick={() => void logout()}>
          Sair
        </Button>
      </div>
    </CenteredScreen>
  )
}

/** Manager of a condominium, but none of the sections is enabled for them in this environment. */
export function NoSectionsScreen() {
  return (
    <div className={styles.inline}>
      <EmptyRow
        icon="lock"
        title="Nenhuma seção disponível"
        description="Você não tem acesso a nenhuma tela deste condomínio por enquanto."
      />
    </div>
  )
}

export function ContextPicker({
  contexts,
  isRoot,
  onPick,
}: {
  contexts: Membership[]
  isRoot: boolean
  onPick: (condoId: number) => void
}) {
  return (
    <CenteredScreen>
      <div className={styles.pickerHead}>
        <h1 className={styles.title}>Escolha um condomínio</h1>
        <p className={styles.subtitle}>
          Você gerencia mais de um. Dá para trocar depois pelo menu da conta.
        </p>
      </div>
      <Card pad={0} className={styles.list}>
        {contexts.map((m) => (
          <Row key={m.condominium_id}>
            <Avatar name={m.condominium_name} size={40} />
            <div className={styles.optionText}>
              <div className={styles.optionName}>{m.condominium_name}</div>
              <div className={styles.optionMeta}>{roleLabel(m.scopes, isRoot)}</div>
            </div>
            <Button size="s" variant="secondary" onClick={() => onPick(m.condominium_id)}>
              Entrar
            </Button>
          </Row>
        ))}
      </Card>
    </CenteredScreen>
  )
}
